import React from 'react';
import Form from 'react-bootstrap/Form';
import { Link } from 'react-router-dom';
import Button from 'react-bootstrap/Button';
import ErrorMessages from '../../components/ErrorMessages';
import { QTD_MAX_BILHETES } from '../../constants';
import { IRifa } from '../../types/rifa';
import { IParceiro } from '../../types/pagamento';

interface Props {
	rifa: IRifa,
	codigoAfiliacao?: string
}

interface State {
	quantidade: number,
	parceiroSelecionado?: IParceiro,
	error?: string
}

class ComprarRifa extends React.Component<Props, State> {
	constructor(props: Props) {
		super(props);

		this.state = {
			quantidade: 1
		}
	}

	diminuirQuantidade = (): void => {
		let {
			quantidade
		} = this.state;

		quantidade -= 1;
		if (quantidade < 1)
			quantidade = 1;

		this.atualizarQuantidade(quantidade);
	}

	aumentarQuantidade = (): void => {
		let {
			quantidade
		} = this.state;

		quantidade += 1;
		this.atualizarQuantidade(quantidade);
	}

	onChangeQuantidade = (event: React.ChangeEvent<HTMLInputElement>): void => {
		const input = event.target;
		let quantidade = 0;
		
		if (!isNaN(parseInt(input.value, 10))) {
			quantidade = parseInt(input.value, 10);
			if (quantidade < 1)
				quantidade = 1;
		}

		this.atualizarQuantidade(quantidade);
	}

	atualizarQuantidade = (quantidade: number): void => {
		if (quantidade > QTD_MAX_BILHETES) {
			this.setState({ 
				quantidade,
				error: `Você pode comprar no máximo ${QTD_MAX_BILHETES} bilhetes de cada vez.` 
			});
		}
		else {
			this.setState({ 
				quantidade,
				error: undefined 
			});
		}
	}

	render(): JSX.Element | null {
		const {
			rifa,
			codigoAfiliacao
		} = this.props;
		const { quantidade, error } = this.state;
		const queryCodigoAfiliacao = codigoAfiliacao ? `&codigoAfiliacao=${codigoAfiliacao}` : '';

		return (
			<div id="comprar-rifa" className="mx-auto my-4">
				<Form>
					<div className="d-block mb-4">
						<div className="d-inline-flex">
							<div className="mr-2">
								<Link to={`pagamento?rifa_grupo=${rifa.id}&comprar_grupo=3${queryCodigoAfiliacao}`}>
									<Button className="btn btn-primary botao-quantidade"> 
										{"3 "}
										<span className="texto-bilhete">
											Bilhetes
										</span>
									</Button>
								</Link>
							</div>

							<div className="mx-2">
								<Link to={`pagamento?rifa_grupo=${rifa.id}&comprar_grupo=5${queryCodigoAfiliacao}`}>
									<Button className="btn btn-primary botao-quantidade"> 
										{"5 "}
										<span className="texto-bilhete">
											Bilhetes
										</span>
									</Button>
								</Link>
							</div>

							<div className="ml-2">
								<Link to={`pagamento?rifa_grupo=${rifa.id}&comprar_grupo=10${queryCodigoAfiliacao}`}>
									<Button className="btn btn-primary botao-quantidade"> 
										{"10 "}
										<span className="texto-bilhete">
											Bilhetes
										</span>
									</Button>
								</Link>
							</div>
						</div>
					</div>

					<div className="d-block d-md-flex justify-content-center">
						<div className="mr-1 d-flex">
							<table id="table-pagamento" className="mx-auto">
								<tbody>
									<tr>
										<td>
											<div className="stepper_handle-counter"
												id="stepper_handleCounter">

												<Button className="stepper_counter-minus stepper_btn stepper_btn btn-primary"
													disabled={quantidade<=1}
													onClick={this.diminuirQuantidade} >
													-
												</Button>
													
												<Form.Group controlId="quantidade-rifas">
													<Form.Control type="text" 
														className="input-qtd-rifa" 
														value={quantidade ? quantidade.toString() : ""}
														onChange={this.onChangeQuantidade}
														pattern="[0-9]+"
														autoComplete="off"
														inputMode="decimal" 
														x-inputmode="decimal"/>
												</Form.Group>
												
												<Button className="stepper_counter-plus stepper_btn stepper_btn btn-primary"
													onClick={this.aumentarQuantidade}
													disabled={quantidade >= QTD_MAX_BILHETES} >
													+
												</Button>
											</div>
										</td>
									</tr>
								</tbody>
							</table>
						</div>

						<div className="d-flex">
							<div className="ml-1 mx-auto mt-2 mt-md-0">
								<Link to={`pagamento?rifa_grupo=${rifa.id}&comprar_grupo=${quantidade}${queryCodigoAfiliacao}`}>
									<Button className="btn stepper_btn btn-primary botao-quantidade" disabled={quantidade > QTD_MAX_BILHETES}> 
										Comprar
									</Button>
								</Link>
							</div>
						</div>
					</div>

					<ErrorMessages errors={error} />
				</Form>
			</div >
		);
	}
}

export default ComprarRifa;